import { useLang } from 'hooks/lang';

import { Column, Row } from 'components/Blocks';
import { CircleAlertIcon } from 'components/Icons';

function NoBalance(): JSX.Element {
  const { t } = useLang();

  return (
    <Column gap="6" alignItems="center" justifyContent="center" className="min-h-[30vh]">
      <Row>
        <CircleAlertIcon color="primary" size={48} />

        <h5>{t('client-with-no-balance-entry')}</h5>
      </Row>

      <p>{t('this-client-is-all-settled-with-us')}</p>
    </Column>
  );
}

export default NoBalance;
